import { useMemo } from 'react';

import { Sources } from 'components/insights/constants';
import useInsightsAnalytics, { InsightsQueryParams } from 'components/insights/query/useInsightsAnalytics';
import { remapReferralsFilters } from 'stores/businessDevelopmentStore';

import useBusinessDevelopmentFilters from './useBusinessDevelopmentFilters';

export type BusinessDevelopmentQueryParams = InsightsQueryParams;

type Options = {
  queryKey?: string;
  enabled?: boolean;
  extraFilters?: Record<string, unknown> | null;
};

export default function useBusinessDevelopmentAnalytics(
  queryParams: BusinessDevelopmentQueryParams,
  { queryKey = 'businessDevelopmentAnalytics', enabled = true, extraFilters = null }: Options = {}
) {
  const filters = useBusinessDevelopmentFilters();

  const resolvedFilters = useMemo(() => {
    if (!filters) return null;

    if (queryParams.source === Sources.INSIGHTS_REFERRALS) {
      return remapReferralsFilters(filters);
    }

    return filters;
  }, [filters, queryParams.source]);

  return useInsightsAnalytics(queryParams, resolvedFilters, { queryKey, enabled, extraFilters });
}
